'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgRunAgain = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20 12c0-1.07-.22-2.12-.64-3.1a7.87 7.87 0 0 0-4.26-4.26A7.87 7.87 0 0 0 9 4.58c-.93.38-1.78.94-2.51 1.63L5.14 4.87a.598.598 0 0 0-.72-.15c-.26.09-.43.34-.42.62V10c.01.37.3.66.67.67h4.66c.27.01.52-.16.61-.42.13-.24.07-.54-.14-.72L8.38 8.1C8.85 7.64 9.4 7.26 10 7c.64-.25 1.32-.38 2-.37a5.334 5.334 0 0 1 4.91 3.26c.56 1.32.56 2.81 0 4.13A5.334 5.334 0 0 1 12 17.28c-1.65.01-3.21-.76-4.21-2.07a.33.33 0 0 0-.24-.12c-.1 0-.19.03-.26.09l-1.42 1.48c-.06.06-.09.13-.09.21 0 .08.02.16.07.23a7.79 7.79 0 0 0 2.75 2.14c1.06.5 2.22.76 3.4.76 1.07 0 2.12-.22 3.1-.64a7.87 7.87 0 0 0 4.26-4.26c.42-.98.64-2.03.64-3.1z",
  fill: "currentColor"
})));

exports["default"] = SvgRunAgain;
